<template lang="pug">
  main#main.account
    b-container(fluid)
      wc-breadcrumb(icon='fal fa-key')
      section.l-section
        .l-section-h
          b-row.mb-5
            b-col
              router-view
</template>

<script>
import WcBreadcrumb from '@components/shared/WcBreadcrumb'

export default {
  name: 'account-show',
  components: {
    WcBreadcrumb,
  },
}
</script>
